import { COMMISSION_CONFIG as C } from "../data/commissionConfig";

const roundTo = (n, inc) => Math.round(n / inc) * inc;

// Pure pricing function. Returns { customQuote, reasons, base, low, high, total }.
export function computeEstimate({ sizeId, figuresId, complexity = [], timelineId }) {
  const size = C.sizes.find((s) => s.id === sizeId);
  const figures = C.figures.find((f) => f.id === figuresId);
  const timeline = C.timelines.find((t) => t.id === timelineId);
  const reasons = [];

  if (!size) return { customQuote: false, reasons, base: null, low: null, high: null, incomplete: true };
  if (size.price == null) reasons.push("Custom / larger canvas");
  if (figures?.custom) reasons.push("4+ primary figures");

  const selections = complexity.filter((c) => c && c !== "None");
  if (selections.length >= C.complexity.customQuoteAt) reasons.push("4+ major complexity factors");

  if (reasons.length) {
    return { customQuote: true, reasons, base: size.price, low: null, high: null };
  }

  const figPct = figures?.pct || 0;
  const compPct = Math.min(selections.length * C.complexity.pctPerSelection, C.complexity.capPct);
  const rushPct = timeline?.pct || 0;

  const total = Math.max(size.price * (1 + figPct + compPct + rushPct), C.minimumPrice);
  const low = Math.max(roundTo(total * (1 - C.rangeSpread), C.roundTo), C.minimumPrice);
  const high = roundTo(total * (1 + C.rangeSpread), C.roundTo);

  return { customQuote: false, reasons, base: size.price, total, low, high };
}

export const money = (n) =>
  typeof n === "number" ? `$${n.toLocaleString("en-US", { maximumFractionDigits: 0 })}` : "";
